import { useEffect, useState } from "react";
import "./styles.css";
import { toast } from "react-toastify";
import { FaPlus } from "react-icons/fa";
import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Table,
} from "reactstrap";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import ModalNovoAlerta from "./ModalNovoAlerta/ModalNovoAlerta";
import Swal from "sweetalert2";
import api from "../../../../services/axiosConfig";

function Alertas() {
  const [listaAlertas, setListaAlertas] = useState([]);
  const [modalAberta, setModalAberta] = useState(false);
  const [alertaSelecionado, setAlertaSelecionado] = useState(null);
  const [filtroTitulo, setFiltroTitulo] = useState("");
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalAlertas, setTotalAlertas] = useState(0);
  const [sortBy, setSortBy] = useState("createdAt");
  const [order, setOrder] = useState("desc");

  async function fetchAlertas() {
    try {
      const params = {
        page,
        limit,
        sortBy,
        order,
        title: filtroTitulo || undefined,
      };

      const response = await api.get("/alerta/admin/listar-tudo", { params });
      setListaAlertas(response.data?.alerts || []);
      setTotalPages(response.data?.pages || 1);
      setTotalAlertas(response.data?.total || 0);
    } catch (error) {
      console.info("Nenhum alerta encontrado:", error);
    }
  }

  useEffect(() => {
    fetchAlertas();
  }, [page, sortBy, order, filtroTitulo]);

  async function handleDeleteAlert(alertId) {
    const result = await Swal.fire({
      title: "Tem certeza?",
      text: "Você não poderá reverter esta ação!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim, excluir!",
      cancelButtonText: "Cancelar",
    });

    if (result.isConfirmed) {
      try {
        await api.delete(`/alerta/${alertId}/excluir`);
        toast.success("O alerta foi removido com sucesso.");
        fetchAlertas();
      } catch (error) {
        console.error("Erro ao excluir alerta:", error);
        toast.error("Erro ao excluir o alerta.");
      }
    }
  }

  const handleEdit = (alerta) => {
    setAlertaSelecionado(alerta);
    setModalAberta(true);
  };

  const handleCreate = () => {
    setAlertaSelecionado(null);
    setModalAberta(true);
  };

  const formatarData = (dataString) => {
    const data = new Date(dataString);
    return data.toLocaleString("pt-BR");
  };

  return (
    <div className="mensagens-container">
      <div className="mensagens-header">
        <h3>Gerenciamento de Alertas</h3>
      </div>

      <Row className="mb-3 d-flex align-items-end">
        <Col md={6}>
          <FormGroup>
            <Label>Buscar por Título</Label>
            <Input
              type="search"
              value={filtroTitulo}
              placeholder="Digite o título do alerta..."
              onChange={(e) => {
                setPage(1);
                setFiltroTitulo(e.target.value);
              }}
            />
          </FormGroup>
        </Col>
        <Col md={6}>
          <div style={{ paddingBottom: "1rem" }}>
            <Button color="primary" onClick={handleCreate}>
              <FaPlus className="me-2" /> Novo Alerta
            </Button>
          </div>
        </Col>
      </Row>

      <div style={{ marginTop: 15, marginBottom: 10 }}>
        <span style={{ fontWeight: "bold", color: "#6d6d6d" }}>
          Total de alertas: {totalAlertas}
        </span>
      </div>

      <Table striped responsive>
        <thead>
          <tr>
            <th
              style={{ cursor: "pointer" }}
              onClick={() => {
                setSortBy("title");
                setOrder(order === "asc" ? "desc" : "asc");
              }}
            >
              Título{" "}
              {sortBy === "title" &&
                (order === "asc" ? <IoIosArrowUp /> : <IoIosArrowDown />)}
            </th>
            <th
              style={{ cursor: "pointer" }}
              onClick={() => {
                setSortBy("required");
                setOrder(order === "asc" ? "desc" : "asc");
              }}
            >
              Obrigatório{" "}
              {sortBy === "required" &&
                (order === "asc" ? <IoIosArrowUp /> : <IoIosArrowDown />)}
            </th>
            <th
              style={{ cursor: "pointer" }}
              onClick={() => {
                setSortBy("createdAt");
                setOrder(order === "asc" ? "desc" : "asc");
              }}
            >
              Data de Criação{" "}
              {sortBy === "createdAt" &&
                (order === "asc" ? <IoIosArrowUp /> : <IoIosArrowDown />)}
            </th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {listaAlertas.map((alerta) => (
            <tr key={alerta._id}>
              <td>{alerta.title}</td>
              <td>{alerta.required ? "Sim" : "Não"}</td>
              <td>{formatarData(alerta.createdAt)}</td>
              <td>
                <Button
                  color="success"
                  size="sm"
                  className="me-2"
                  onClick={() => handleEdit(alerta)}
                >
                  Editar
                </Button>
                <Button
                  color="danger"
                  size="sm"
                  onClick={() => handleDeleteAlert(alerta._id)}
                >
                  Excluir
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {listaAlertas.length === 0 && (
        <p className="text-center">Nenhum alerta encontrado.</p>
      )}

      <Pagination
        style={{ display: "flex", justifyContent: "center", marginTop: 20 }}
      >
        <PaginationItem disabled={page === 1}>
          <PaginationLink previous onClick={() => setPage(page - 1)} />
        </PaginationItem>
        {[...Array(totalPages).keys()].map((i) => (
          <PaginationItem active={page === i + 1} key={i}>
            <PaginationLink onClick={() => setPage(i + 1)}>
              {i + 1}
            </PaginationLink>
          </PaginationItem>
        ))}
        <PaginationItem disabled={page >= totalPages}>
          <PaginationLink next onClick={() => setPage(page + 1)} />
        </PaginationItem>
      </Pagination>

      <ModalNovoAlerta
        isOpen={modalAberta}
        onClose={() => {
          setModalAberta(false);
          fetchAlertas();
        }}
        alertaSelecionado={alertaSelecionado}
      />
    </div>
  );
}

export default Alertas;
